import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import PersonCard from '../components/common/PersonCard';

const segretari = [
  { name: 'Francesco Morelli', role: 'Segretario Regionale', territory: 'Lombardia', avatarColor: '#e27314' },
  { name: 'Claudia De Luca', role: 'Segretaria Regionale', territory: 'Lazio', avatarColor: '#7a1f1c' },
  { name: 'Elena Santoro', role: 'Segretaria Regionale', territory: 'Toscana', avatarColor: '#c94f7c' },
  { name: 'Roberto Esposito', role: 'Segretario Regionale', territory: 'Campania', avatarColor: '#b85a0f' },
  { name: 'Lucia Di Maio', role: 'Segretaria Regionale', territory: 'Emilia-Romagna', avatarColor: '#57110f' },
  { name: 'Andrea Ferraro', role: 'Segretario Regionale', territory: 'Piemonte', avatarColor: '#a03a36' },
  { name: 'Simone Catania', role: 'Segretario Regionale', territory: 'Sicilia', avatarColor: '#e27314' },
  { name: 'Martina Ferro', role: 'Segretaria Regionale', territory: 'Puglia', avatarColor: '#c94f7c' },
  { name: 'Marco Veronese', role: 'Segretario Regionale', territory: 'Veneto', avatarColor: '#7a1f1c' },
  { name: 'Sara Calabrese', role: 'Segretaria Regionale', territory: 'Calabria', avatarColor: '#b85a0f' },
  { name: 'Giorgio Sardo', role: 'Segretario Regionale', territory: 'Sardegna', avatarColor: '#57110f' },
  { name: 'Anna Ligure', role: 'Segretaria Regionale', territory: 'Liguria', avatarColor: '#a03a36' },
];

const SegretariPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Chi Siamo', path: '/chi-siamo' }, { label: 'Segretari Regionali' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Territorio" title="Segretari Regionali" subtitle="I 20 segretari regionali dei Giovani Democratici, un referente per ogni regione d'Italia." />
      <section className="section"><div className="container">
        <div className="grid grid-4">
          {segretari.map((p) => <PersonCard key={p.name} {...p} as="a" link="/persona-dettaglio" />)}
        </div>
      </div></section>
    </Layout>
  );
};

export default SegretariPage;
